import { AtemApplication } from "../modules/user/domain/constants";
import { applicationListRules } from "../utils/applicationRules";
import { AccessContext } from "./types";
import { resolveBrand } from "./brandRegistry";

// Variante de tela a renderizar por rota (login e fluxo de senha). Os 5 membros cobrem
// todos os dispatchers: IDP, Trading, NotPortal, Branded (marca não-default) e Default.
export enum ScreenVariant {
  IDP = "IDP",
  TRADING = "TRADING",
  NOT_PORTAL = "NOT_PORTAL",
  BRANDED = "BRANDED",
  DEFAULT = "DEFAULT",
}

type ApplicationResolver = (ctx: AccessContext) => AtemApplication | applicationListRules;

// Decisão pura de qual variante de tela renderizar. O resolvedor de aplicação (injetado)
// já aplica o travamento por domínio; aqui só mapeamos fluxo → variante, e no fluxo Default
// escolhemos BRANDED quando a marca resolvida não é a default.
export function selectScreen(
  ctx: AccessContext,
  resolveApplication: ApplicationResolver
): ScreenVariant {
  const application = resolveApplication(ctx);

  switch (application) {
    case AtemApplication.IDP:
      return ScreenVariant.IDP;
    case applicationListRules.PORTAL_TRADING:
      return ScreenVariant.TRADING;
    case AtemApplication.CHECKLIST:
    case AtemApplication.SUPPLY_CHAIN:
    case AtemApplication.SALES_PORTAL:
    case AtemApplication.LOADING:
    case AtemApplication.SALES:
      return ScreenVariant.NOT_PORTAL;
    default:
      return resolveBrand(ctx).id !== "default" ? ScreenVariant.BRANDED : ScreenVariant.DEFAULT;
  }
}
